export const routeLoaderKeys = {
  organizer: ["organizer"],
  vendor: ["vendor"],
  basic: ["basic"],
  common: ["organizer", "vendor"],
};
